import type { BrandConfig } from "./brand-schema";

export const activeBrand = {
  id: "delta-adaptive-systems",
  name: "Delta Adaptive Systems",
  compactName: "DA Systems",
  desktopName: "Delta Adaptive Systems Desktop",
  supportTeamName: "Delta Adaptive Systems team",
  supportEmail: "support@das.dev",
  wordmark: {
    leading: "DA",
    accent: "Systems",
    separator: " ",
  },
  rootDomain: "das.dev",
  shellOrigin: "https://app.das.dev",
  stagingShellOrigin: "https://app-staging.das.dev",
  markPath:
    "M129.72,65h-3.32c-6.12,0-11.78,3.25-14.87,8.54l-68.52,117.46h13.47c6.07,0,11.66-3.33,14.57-8.66l56.94-99.94,36.1,63.37,20.92,36.72c2.86,5.25,8.37,8.51,14.34,8.51h13.62l-68.58-117.57c-3.05-5.22-8.63-8.43-14.68-8.43ZM105.04,154.32l-5.14,8.91h56.15l-5.08-8.8c-3.09-5.36-8.81-8.66-14.99-8.66h-16.12c-6.11,0-11.76,3.26-14.81,8.55Z",
  markViewBox: "0 0 256 256",
  assets: {
    logo: "/das-logo.svg",
    favicon: "/das-favicon.svg",
    appleTouchIcon: "/icons/das-180.png",
    icons: [
      { src: "/icons/das-180.png", sizes: "180x180", purpose: "any" },
      { src: "/icons/das-192.png", sizes: "192x192", purpose: "any" },
      { src: "/icons/das-512.png", sizes: "512x512", purpose: "any" },
      {
        src: "/icons/das-maskable-512.png",
        sizes: "512x512",
        purpose: "maskable",
      },
    ],
  },
  colors: {
    background: "#FAFBFC",
    theme: "#1D5583",
  },
  copy: {
    applicationDescription:
      "Delta Adaptive Systems gives organizations a calm, secure home for purpose-built operational tools.",
    manifestDescription:
      "A secure home for purpose-built operational tools from your organization.",
  },
} satisfies BrandConfig;

export function isWorkspaceBrandHostname(hostname: string): boolean {
  return workspaceLabelFromBrandHostname(hostname) !== null;
}

export function isNeutralShellOrigin(origin: string): boolean {
  return origin === activeBrand.shellOrigin || origin === activeBrand.stagingShellOrigin;
}

export function isLocalDevelopmentShellOrigin(origin: string): boolean {
  try {
    const parsed = new URL(origin);
    return (
      parsed.protocol === "http:" &&
      parsed.hostname === "localhost" &&
      parsed.port !== "" &&
      Number(parsed.port) > 0 &&
      parsed.origin === origin
    );
  } catch {
    return false;
  }
}

export function workspaceLabelFromBrandHostname(hostname: string): string | null {
  const normalized = hostname.toLowerCase();
  const suffix = `.${activeBrand.rootDomain}`;
  if (!normalized.endsWith(suffix)) return null;
  const environmentLabel = normalized.slice(0, -suffix.length);
  if (!environmentLabel || environmentLabel.includes(".")) return null;
  if (["app", "app-staging"].includes(environmentLabel)) return null;
  return environmentLabel.endsWith("-staging")
    ? environmentLabel.slice(0, -"-staging".length)
    : environmentLabel;
}
